import { render, staticRenderFns } from "./EventFeature.vue?vue&type=template&id=16797136&scoped=true&"
import script from "./EventFeature.vue?vue&type=script&lang=js&"
export * from "./EventFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16797136",
  null
  
)

export default component.exports